import { MessageCircle } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";

const BEACH_BG = "/assets/images/huatulco-bg.webp";

const ContactSection = ({ onOpenWhatsApp }) => {
  const { t, lang } = useLanguage();

  return (
    <section className="relative py-20 md:py-28" data-testid="contact-section">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${BEACH_BG})` }} />
      <div className="absolute inset-0 bg-white/90" />
      <div className="max-w-3xl mx-auto px-4 md:px-8 relative z-10">
        <div className="text-center mb-8">
          <span className="text-xs uppercase tracking-[0.3em] text-[#B5613B] font-accent mb-4 block">{t.contact.label}</span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-[#2D2926] mb-4" data-testid="contact-title">{t.contact.title}</h2>
          <p className="text-[#6B6560] leading-relaxed">{t.contact.desc}</p>
        </div>
        <div className="text-center mb-8">
          <button onClick={onOpenWhatsApp} data-testid="contact-whatsapp-cta" className="inline-flex items-center justify-center gap-3 bg-[#25D366] hover:bg-[#20bd5a] text-white px-8 py-4 uppercase tracking-widest text-sm font-medium transition-all duration-300 hover:scale-105 shadow-lg">
            <MessageCircle className="w-5 h-5" />
            {t.contact.ctaWhatsApp}
          </button>
          <div className="flex items-center gap-4 mt-8">
            <div className="flex-1 h-px bg-[#2D2926]/15" />
            <span className="text-xs uppercase tracking-widest text-[#6B6560]">{t.contact.or}</span>
            <div className="flex-1 h-px bg-[#2D2926]/15" />
          </div>
        </div>
        <div className="bg-white p-6 md:p-8 shadow-xl border border-[#B5613B]/10" data-testid="contact-form-container">
          {lang === "es" ? (
            <iframe src="https://links.thefunnelbox.com/widget/form/vNCoIFc0uic2mzWRPXV6" style={{ width: "100%", height: "896px", border: "none", borderRadius: "3px" }} id="inline-vNCoIFc0uic2mzWRPXV6" data-layout="{'id':'INLINE'}" data-trigger-type="alwaysShow" data-trigger-value="" data-activation-type="alwaysActivated" data-activation-value="" data-deactivation-type="neverDeactivate" data-deactivation-value="" data-form-name="ESPAÑOL Form GRAL | Landing page Google Ads" data-height="896" data-layout-iframe-id="inline-vNCoIFc0uic2mzWRPXV6" data-form-id="vNCoIFc0uic2mzWRPXV6" title="ESPAÑOL Form GRAL | Landing page Google Ads" />
          ) : (
            <iframe src="https://links.thefunnelbox.com/widget/form/uqpddeaNIwng6EWC0BUx" style={{ width: "100%", height: "578px", border: "none", borderRadius: "3px" }} id="inline-uqpddeaNIwng6EWC0BUx" data-layout="{'id':'INLINE'}" data-trigger-type="alwaysShow" data-trigger-value="" data-activation-type="alwaysActivated" data-activation-value="" data-deactivation-type="neverDeactivate" data-deactivation-value="" data-form-name="English Form GRAL | Landing page Google Ads" data-height="578" data-layout-iframe-id="inline-uqpddeaNIwng6EWC0BUx" data-form-id="uqpddeaNIwng6EWC0BUx" title="English Form GRAL | Landing page Google Ads" />
          )}
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
